package com.vizio.redwolf.utils

data class PurchasePinEnvironmentConfig(val environmentGroup: EnvironmentGroup)